import './LoggerService';
import './UniqueIdService';
import './TranslationService';
import './BrowserControlService';
import './ThemerService';
import './LogicService';
import './SharedQuestionService';
import './SessionService';
import './QuestionnaireService';
import './SpinnerService';
import './ErrorService';

import * as authProvider from './authProvider';

let luminaQuestionnaireServices = angular.module(
    'luminaQuestionnaireServices',
    ['ngResource', 'auth0.auth0', 'luminaQuestionnaireConfig']
);

// Used to save language when chaining to user_metadata
luminaQuestionnaireServices.factory('luminaProfile', [
    '$resource', 'luminaEnv',
    function ($resource, luminaEnv) {
        return $resource(luminaEnv.ssoUrl + '/api/profile', {}, {
            saveUserMetadata: {
                method : 'POST',
                url    : luminaEnv.ssoUrl + '/api/profile/metadata',
                isArray: false
            },
            whoAmI          : {
                method : 'GET',
                url    : luminaEnv.ssoUrl + '/api/me',
                isArray: false
            },
            whoAmIToKeycloak: {
                method : 'GET',
                url    : luminaEnv.ssoUrl + '/api/keycloak/me',
                isArray: false
            },
            saveKeycloakUserLanguage: {
                method : 'POST',
                url    : luminaEnv.ssoUrl + '/api/keycloak/change-language',
                isArray:false
            }
        });
    }
]);

// Setup authService as a provider so it is available during the config stage
luminaQuestionnaireServices.provider(
    'authService',
    ['angularAuth0Provider', 'luminaEnv', authProvider]
);

// Include separate services
import './returnUrlSanitise';